module.exports = __webpack_public_path__ + "img/historia22.a93a3f3a.jpg";